// extracted by extract-css-chunks-webpack-plugin
module.exports = {"stretch":"form__stretch--2EwBm"};